import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { TRANSLATION_LOCALES } from "@faire/web--source/common/rsc/localization/TRANSLATION_LOCALES";
export var parseDictionary = function(content) {
    return JSON.parse(content);
};
// ts-prune-ignore-next
export var INITIAL_LOCALE_DICTIONARY = TRANSLATION_LOCALES.reduce(function(acc, locale) {
    return _object_spread_props(_object_spread({}, acc), _define_property({}, locale, {}));
}, {});
export var INITIAL_INTL_MAP = TRANSLATION_LOCALES.reduce(function(acc, locale) {
    return _object_spread_props(_object_spread({}, acc), _define_property({}, locale, {}));
}, {});
/**
 * Matches the locale in the url to the name of the translation file
 */ export var getTranslationLocale = function(locale) {
    var determineLocale = function(locale) {
        var _locale_split = _sliced_to_array(locale.split("-"), 2), lang = _locale_split[0], country = _locale_split[1];
        // Special case for English
        if (lang === "en") {
            if ((country === null || country === void 0 ? void 0 : country.toUpperCase()) === "GB") {
                return "en_GB";
            }
            return "en_US";
        }
        var langTranslationLocale = TRANSLATION_LOCALES.find(function(l) {
            return l.startsWith(lang);
        });
        if (!country) {
            return langTranslationLocale;
        }
        var _TRANSLATION_LOCALES_find;
        return (_TRANSLATION_LOCALES_find = TRANSLATION_LOCALES.find(function(l) {
            return l.startsWith("".concat(lang, "_").concat(country.toUpperCase()));
        })) !== null && _TRANSLATION_LOCALES_find !== void 0 ? _TRANSLATION_LOCALES_find : langTranslationLocale;
    };
    var _determineLocale, _ref;
    return (_ref = (_determineLocale = determineLocale(locale)) !== null && _determineLocale !== void 0 ? _determineLocale : determineLocale("en")) !== null && _ref !== void 0 ? _ref : "en_US";
};
